import { connect } from 'react-redux';
import PrConfirmationDetails from './prConfirmationDetails'
import { bindActionCreators } from 'redux';
import {
    getPrConfirmationDetails, approvePRRequest, updatePR
} from 'services/redux/installation/siteListing/action';
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    prConfirmationDetails: state.siteListingReducer.prConfirmationDetails,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPrConfirmationDetails,
      approvePRRequest,
      updatePR,
      documentUploadUrlPublic
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(PrConfirmationDetails);
